import { render, staticRenderFns } from "./iconRef.vue?vue&type=template&id=5f569167&scoped=true&"
import script from "./iconRef.vue?vue&type=script&lang=js&"
export * from "./iconRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f569167",
  null
  
)

export default component.exports